import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {LOGIN_TO} from '~/constant/login';
import './index.less';

const LoginHeader = props => {
    const {to, agent: {isMobile}} = props;
    let explain = '单点登录系统';
    let extra = null;
    if (to === LOGIN_TO.ACCOUNT_PASSWORD) {
        explain = '单点登录系统';
        extra = null;
    }
    else if (to === LOGIN_TO.PHONE_CODE) {
        explain = '安全验证';
        extra = (
            <section className="login-header-extra">
                <p>
                    为了确保为您本人操作，请先进行安全验证。
                </p>
                <p>
                    每天12点到0点同一手机号有且只能发送8条验证码的短信。
                </p>
            </section>
        );
    }

    return (
        isMobile
            ? (
                <header className="h5-login-header">
                    <section className="login-header-title">
                        <div className="login-explain">
                            {explain}
                        </div>
                    </section>
                    {extra}
                </header>
            )
            : (
                <header className="web-login-header">
                    <section className="login-header-title">
                        <div className="login-explain">
                            {explain}
                        </div>
                    </section>
                    {extra}
                </header>
            )

    );
};

LoginHeader.propTypes = {
    to: PropTypes.string.isRequired,
    agent: PropTypes.shape({
        isMobile: PropTypes.bool.isRequired
    }).isRequired,
};

export default connect(({agent}) => ({agent}))(LoginHeader);
